<template>
  <div class="mune">
      <!--ul class="mune_main">
        <li>
          <router-link  to='/userCenter/mall/mall'>
          <p class="icon-shop icon_size icon_size1"></p>
          <p class="icon_name">券币商城</p>
          </router-link>
        </li>
        <li>
          <router-link to="/userCenter/couponFan">
            <p class="icon-ticket2 icon_size icon_size2"></p>
            <p class="icon_name" >领券实况</p>
          </router-link>
        </li>
        <li>
          <router-link  to='/userCenter/help'>
            <p class="icon-vedio1 icon_size icon_size3"></p>
            <p class="icon_name" >使用教程</p>
          </router-link>
        </li>
        <li>
          <router-link  to='/userCenter/news/news'>
            <p class="icon-email3 icon_size icon_size4">
              <span class="icon_sizenum">1</span>
            </p>
            <p  class="icon_name">消息中心</p>
          </router-link>
        </li>
      </ul-->
      <ul class="list_wrapper mt20">
        <!--li class="row">
          <span class="row_icon icon-drying_list drying_list"></span>
          <div class="row_text bbline">
            <span class="row_name">主页动态</span>
            <span><span class="news">8</span><span class="icon-before row_right_icon"></span></span>
          </div>
        </li-->
        <li class=" mt20">
          <router-link class="row"  to='/userCenter/mall/mall'>
            <span class="row_icon icon-shop icon_size1"></span>
             <div class="row_text bbline">
              <span class="row_name">券币商场</span>
              <span><span class="icon-before row_right_icon"></span></span>
            </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link class="row"  to="/userCenter/couponFan">
            <span class="icon-ticket2 row_icon icon_size2"></span>
            <div class="row_text bbline">
             <span class="row_name">领券实况</span>
             <span><span class="icon-before row_right_icon"></span></span>
           </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link class="row"   to='/userCenter/help'>
            <span class="icon-vedio1 row_icon icon_size3"></span>
            <div class="row_text bbline">
             <span class="row_name">使用教程</span>
             <span><span class="icon-before row_right_icon"></span></span>
           </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link class="row" to="/userCenter/coinsCenter">
          <span class="row_icon icon-purse purse"></span>
          <div class="row_text bbline">
            <span class="row_name">券币中心</span>
            <span><span class="icon-before row_right_icon"></span></span>
          </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link class="row" to="/userCenter/buyScoreMallGoodRecord">
          <span class="row_icon icon-gift1 gift1"></span>
          <div class="row_text bbline">
            <span class="row_name">礼品兑换记录</span>
            <span><span class="icon-before row_right_icon"></span></span>
          </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link to="/userCenter/orderScore" class="row" >
            <span class="row_icon icon-edit edit"></span>
            <div class="row_text bbline">
              <span class="row_name">提交订单赚券币</span>
              <span><span class="icon-before row_right_icon"></span></span>
            </div>
          </router-link>
        </li>
        <!--li class=" mt20">
          <router-link to="/userCenter/promotePost"  class="row">
            <span class="row_icon icon-share3 share3"></span>
            <div class="row_text">
              <span class="row_name">分享赚券币</span>
              <span><span class="icon-before row_right_icon"></span></span>
            </div>
          </router-link>
        </li-->
      </ul>
      <!--ul class="list_wrapper mt20">
        <li>
          <router-link to="/userCenter/promotePost"  class="row">
        `  <span class="row_icon icon-set set"></span>
          <div class="row_text bbline">
            <span class="row_name">服务通知设置</span>
            <span><span class="icon-before row_right_icon"></span></span>
          </div>`
          </router-link>
        </li>
        <li class="mt20">
          <router-link to="/userCenter/bePromoter"  class="row">
          <span class="row_icon icon-cobber cobber"></span>
          <div class="row_text">
            <span class="row_name">申请成为合伙人</span>
            <span><span class="icon-before row_right_icon"></span></span>
          </div>
          </router-link>
        </li>
      </ul-->
      <!--div class="title">管理员
      </div>
      <ul class="list_wrapper mt20">
        <li class="row">
          <span class="row_icon icon-duihuan duihuan"></span>
          <div class="row_text bbline">
            <span class="row_name">兑换受理</span>
            <span><span class="news">8</span><span class="icon-before row_right_icon"></span></span>
          </div>
        </li>
        <li class="row mt20">
          <span class="row_icon icon-user1 duihuan"></span>
          <div class="row_text bbline">
            <span class="row_name">晒单评论审核</span>
            <span><span class="icon-before row_right_icon"></span></span>
          </div>
        </li>
        <li class="row mt20">
          <span class="row_icon icon-system_set duihuan"></span>
          <div class="row_text">
            <span class="row_name">系统功能</span>
            <span><span class="icon-before row_right_icon"></span></span>
          </div>
        </li>
      </ul-->
      <!--div class="title">推广中心
      </div>
      <ul class="list_wrapper mt20">
        <li>
          <router-link to="/userCenter/myUser" class="row">
          <span class="row_icon icon-user2 tuiguang"></span>
          <div class="row_text bbline">
            <span class="row_name">我的用户</span>
            <span><span class="row_right_text">258人</span><span class="icon-before row_right_icon"></span></span>
          </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link to="/userCenter/myOrderList"  class="row">
            <span class="row_icon icon-outstanding tuiguang"></span>
            <div class="row_text bbline">
              <span class="row_name">我的业绩</span>
              <span><span class="icon-before row_right_icon"></span></span>
            </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link to="/userCenter/myPromoters"  class="row">
            <span class="row_icon icon-user3 tuiguang"></span>
            <div class="row_text bbline">
              <span class="row_name">我的推广员</span>
              <span><span class="row_right_text">1人</span><span class="icon-before row_right_icon"></span></span>
            </div>
          </router-link>
        </li>
        <li class=" mt20">
          <router-link to="/userCenter/myRanking"  class="row">
            <span class="row_icon icon-ranking tuiguang"></span>
            <div class="row_text">
              <span class="row_name">排行榜</span>
              <span><span class="row_right_text">NO.1</span><span class="icon-before row_right_icon"></span></span>
            </div>
          </router-link>
        </li>
      </ul-->
  </div>
</template>
<script type = "text/ecamscript-6">
/* eslint-disable */
  export default {
    name:"mune",
  }
</script>
<style lang="stylus">
  .mune
    padding-bottom:10px
    .mune_main
      margin:20px auto 0 auto
      width:710px
      height:175px
      padding:35px 50px 0
      background:#fff
      display:flex
      justify-content:space-between
      box-sizing:border-box
      border-radius:20px
      .icon_size
        font-size:64px
        text-align:center
        -webkit-background-clip: text
        -webkit-text-fill-color: transparent
        &.icon_size1
          background-image:linear-gradient(to right,#a166e4,#a166e4)
        &.icon_size2
          background-image:linear-gradient(to right,#facf50,#ff6826)
        &.icon_size3
          background-image:linear-gradient(to right,#40ddaa,#27add3)
        &.icon_size4
          background-image:linear-gradient(to right,#fc925c,#f43675)
          position:relative
          .icon_sizenum
            background:#ff4200
            width:40px
            height:40px
            border-radius:20px
            border:2px solid #fff
            /*px*/
            display:inline-block
            box-sizing:border-box
            position:absolute
            right:11px
            bottom:-5px
            font-size:24px
            color:#fff
            line-height:38px
            text-align:center
            -webkit-text-fill-color:#fff
      .icon_name
        font-size:24px
        color:#333
        margin-top:15px
    .list_wrapper
      background:#fff
      border-radius:20px
      width:710px
      margin-right:auto
      margin-left:auto
      padding-top:20px
      .row
        display:flex
        padding:0 25px 0 35px
        .row_icon
          flex:0 0 80px
          font-size:55px
          &.drying_list
            color:#fdb333
          &.purse
            color:#ff531e
          &.purse
            color:#ff531e
          &.gift1
            color:#fdb333
          &.edit
            color:#27b6ff
          &.share3
            color:#3fdaac
          &.set
            color:#27b6ff
          &.cobber
            color:#fdb333
          &.duihuan
            color:#27b6ff
            font-size:45px
          &.tuiguang
            color:#fdb333
            font-size:45px
          &.icon_size1
            -webkit-background-clip: text
            -webkit-text-fill-color: transparent
            background-image:linear-gradient(to right,#a166e4,#a166e4)
          &.icon_size2
            -webkit-background-clip: text
            -webkit-text-fill-color: transparent
            background-image:linear-gradient(to right,#facf50,#ff6826)
          &.icon_size3
            -webkit-background-clip: text
            -webkit-text-fill-color: transparent
            background-image:linear-gradient(to right,#40ddaa,#27add3)
          &.icon_size4
            -webkit-background-clip: text
            -webkit-text-fill-color: transparent
            background-image:linear-gradient(to right,#fc925c,#f43675)
        .row_text
          flex:1
          padding-bottom:25px
          display:flex
          justify-content:space-between
          line-height:55px
          .row_name
            font-size:28px
            color:#333
          .news
            width:36px
            height:36px
            background:#ff4200
            text-align:center
            line-height:36px
            color:#fff
            font-size:24px
            display:inline-block
            line-height:36px
            border-radius:18px
            margin-right:10px
            vertical-align:middle
          .row_right_icon
            font-size:30px
            color:#999
            vertical-align:middle
          .row_right_text
            color:#999
            font-size:28px
    .title
      font-size:24px
      color:#999
      line-height:30px
      width:710px
      margin:30px auto 0 auto
      padding-left:50px
      box-sizing:border-box






</style>



// WEBPACK FOOTER //
// src/components/userCenter/userCenter/mune.vue